import React, { useState } from "react";
import NavHeader from "../../Common/NavHeader";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { register } from "../api";
import { Link } from "react-router-dom";

export default function Registration() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    password: "",
    cpassword: "",
    email: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.cpassword) {
      toast.error("Password and Confirm Password should be same");
      return;
    }
    setLoading(true);
    const response = await register(formData);
    if (response.data.status === 201) {
      toast.success(response.data.message);
      setFormData({
        first_name: "",
        last_name: "",
        username: "",
        password: "",
        cpassword: "",
        email: "",
      });
    } else {
      toast.error(response.data.message);
      setFormData({
        first_name: "",
        last_name: "",
        username: "",
        password: "",
        cpassword: "",
        email: "",
      });
    }
    setLoading(false);
  };
  return (
    <>
      <NavHeader view="Registration" />
      <ToastContainer />
      <Container fluid className="mt-5">
        <Row>
          <Col md={4} xs={12} className="bg-body-tertiary p-4">
            <Form
              onSubmit={handleSubmit}
              style={{
                marginTop: "20%",
              }}
            >
              <h2 className="text-center">Register Here</h2>
              <Form.Group controlId="formUsername">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter First Name"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formUsername">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Last Name"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formUsername">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter a username"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="formPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="formPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="cpassword"
                  placeholder="Confirm password"
                  name="cpassword"
                  value={formData.cpassword}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Button
                type="submit"
                disabled={loading}
                className="my-4"
                style={{
                  width: "100%",
                }}
              >
                {loading ? "Registering..." : "Register"}
              </Button>
            </Form>
            <p className="my-1 text-center">Already registered? <Link to="/login">Login Here</Link></p>
          </Col>

          {/* Right 60% - Image */}
          <Col md={8} className="d-none d-md-block p-0">
            <img
              src={`${process.env.PUBLIC_URL}/regn.png`}
              alt="Registration"
              className="img-fluid w-100"
            />
          </Col>
        </Row>
      </Container>
    </>
  );
}
